import { render, staticRenderFns } from "./FileForm.vue?vue&type=template&id=22e0c1a2&scoped=true&"
import script from "./FileForm.vue?vue&type=script&lang=js&"
export * from "./FileForm.vue?vue&type=script&lang=js&"
import style0 from "./FileForm.vue?vue&type=style&index=0&id=22e0c1a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e0c1a2",
  null
  
)

export default component.exports